// components
import CommonActionModal from "../Common/CommonActionModal";

// icons
import TableViewIcon from "@mui/icons-material/TableView";
import LinkIcon from "@mui/icons-material/Link";
import DeliveryControlledEntityInner from "./DeliveryControlledEntityInner";


class DeliveryControlledEntityModal extends CommonActionModal {
    async componentDidMount() {
        this.setState({
            buttonIcon: LinkIcon,
            buttonColor: 'neutral',
            buttonVariant: 'soft',
            ready: true,
            flat: true
        })
    }

    async beforeModalOpen(){
        return {
            modalLabel: 'Контролируемые сущности',
            modalIcon: TableViewIcon,
            mainComponent: DeliveryControlledEntityInner,
            mainComponentProps: {
                delivery: this.props.delivery,
            },
        }
    }
}

export default DeliveryControlledEntityModal
